import React, { ReactNode } from 'react'

import classNames from 'classnames'

import style from './Stack.module.css'

type PropsType = {
  children: ReactNode
  className?: string
}

export const Stack = ({ children, className = '' }: PropsType) => {
  return <div className={classNames(style.stack, className)}>{children}</div>
}
